module.exports = __webpack_public_path__ + "img/LP_Full_Pink.8c3bde37.svg";